export const TEXT_AREA_DATA_HOOK = 'text-area';
/** on div that contains icon tooltip */
export const TEXT_AREA_ERROR_DATA_HOOK = 'text-area-error-icon';
export const LABEL_DATA_HOOK = 'text-area-label';
export const CHAR_COUNTER_DATA_HOOK = 'char-counter';
/** on icon tooltip */
export const ERROR_ICON_DATA_HOOK = 'error-Icon';
export const LABEL_ASTERISK_DATA_HOOK = 'label-asterisk';
//# sourceMappingURL=dataHooks.js.map